import React, { useState } from 'react';
import cx from 'classnames';
import Chip, { Color } from 'lib/Chip';
import Button, { Color as ButtonColor } from 'lib/Button';
import chevronDown from 'assets/icons/arrow_light_down.svg';
import { AssetItem } from 'components/pages/Planner/PlannerMap/useFurniture.types';
import CopyToClipboardButton from 'components/common/CopyToClipboardButton';
import CampaignPlanSingleFurnitureCardItem from '../CampaignPlanSingleFurnitureCard/CampaignPlanSingleFurnitureCardItem';

interface CampaignPlanMultiFrameCardProps {
  furnitureCode: string;
  assets: AssetItem[];
}

const CampaignPlanMultiFrameCard: React.FC<CampaignPlanMultiFrameCardProps> = ({ furnitureCode, assets }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      data-test-id={`campaign-plan-multi-frame-card-${furnitureCode}`}
      className="rounded-xl border border-gray-200 bg-white hover:bg-neutral-100"
    >
      <div className="w-full flex items-start justify-between mb-1 pt-3 px-3">
        <div className="w-full flex justify-between">
          <div className="w-3/5 flex flex-col space-y-1">
            <div className="w-full flex items-start justify-start group">
              <span className="w-full flex-none font-bold body-lg whitespace-nowrap overflow-hidden truncate">
                {furnitureCode}
              </span>
              <CopyToClipboardButton
                dataTestId={`campaign-plan-copy-${furnitureCode}`}
                textToCopy={furnitureCode}
                color={ButtonColor.TERTIARY}
                svgClassnames="w-3 h-3 text-neutral-900"
                buttonClassnames="!p-1 opacity-0 group-hover:opacity-100"
                isDisabled={false}
              />
            </div>
          </div>
          <Chip
            label={assets[0].isDigital ? 'Digital' : 'Paper'}
            color={Color.PRIMARY}
            subLabel={assets.length.toString()}
          />
        </div>
      </div>
      <div className="w-full border-t-2 flex justify-between items-center mt-4 px-3 py-2">
        <strong className="sub-header-base">View frames</strong>
        <Button
          dataTestId={`campaign-plan-view-frames-${furnitureCode}`}
          classNames={cx({ 'rotate-180': isOpen })}
          svg={chevronDown}
          color={ButtonColor.GREY}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      {isOpen && (
        <div className="w-full flex flex-col space-y-2 py-2 px-3">
          {assets.map((asset) => (
            <CampaignPlanSingleFurnitureCardItem
              key={asset.frameId}
              frameId={asset.frameId}
              isDigital={asset.isDigital}
              frameSize={asset.frameSize}
              impressions={asset.impressions}
              isImpressions={asset.isImpressions ?? false}
              sot={asset.sot}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CampaignPlanMultiFrameCard;
